module.exports = __webpack_public_path__ + "img/nails-lg.e64ad402.png";